import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0b61cbe1")
const _hoisted_1 = {
  key: 0,
  class: "page"
}
const _hoisted_2 = { class: "detail-grid" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "ID Rimborso", -1)
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Stato", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "detail-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Importo", -1)
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "detail-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Data Richiesta", -1)
const _hoisted_14 = { class: "value" }
const _hoisted_15 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Data Elaborazione", -1)
const _hoisted_17 = { class: "value" }
const _hoisted_18 = {
  key: 1,
  class: "detail-item"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Note Amministratore", -1)
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "detail-grid" }
const _hoisted_22 = { class: "detail-item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "IBAN", -1)
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "detail-item" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "Intestatario IBAN", -1)
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "detail-grid" }
const _hoisted_29 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, "Codice Fiscale", -1)
const _hoisted_31 = { class: "value" }
const _hoisted_32 = {
  key: 1,
  class: "detail-item"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Partita IVA", -1)
const _hoisted_34 = { class: "value" }
const _hoisted_35 = {
  key: 2,
  class: "detail-item"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "Ragione Sociale", -1)
const _hoisted_37 = { class: "value" }
const _hoisted_38 = {
  key: 3,
  class: "detail-item"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "Indirizzo", -1)
const _hoisted_40 = { class: "value" }
const _hoisted_41 = {
  key: 4,
  class: "detail-item"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", null, "Città", -1)
const _hoisted_43 = { class: "value" }
const _hoisted_44 = {
  key: 5,
  class: "detail-item"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", null, "Provincia ", -1)
const _hoisted_46 = { class: "value" }
const _hoisted_47 = {
  key: 6,
  class: "detail-item"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", null, "Telefono", -1)
const _hoisted_49 = { class: "value" }
const _hoisted_50 = {
  key: 7,
  class: "detail-item"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", null, "Note", -1)
const _hoisted_52 = { class: "value" }
const _hoisted_53 = { class: "detail-grid" }
const _hoisted_54 = { class: "detail-item" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", null, "Nome", -1)
const _hoisted_56 = { class: "value" }
const _hoisted_57 = { class: "detail-item" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", null, "Email", -1)
const _hoisted_59 = { class: "value" }
const _hoisted_60 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", null, "Ragione Sociale", -1)
const _hoisted_62 = { class: "value" }
const _hoisted_63 = {
  key: 1,
  class: "detail-item"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", null, "P.IVA", -1)
const _hoisted_65 = { class: "value" }
const _hoisted_66 = { class: "detail-item" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", null, "Rating", -1)
const _hoisted_68 = { class: "value" }
const _hoisted_69 = { class: "rating-display" }
const _hoisted_70 = { class: "rating-number" }
const _hoisted_71 = {
  key: 1,
  class: "page"
}
const _hoisted_72 = {
  key: 2,
  class: "page"
}
const _hoisted_73 = /*#__PURE__*/_createTextVNode("Rimborso non trovato")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Rating = _resolveComponent("Rating")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Message = _resolveComponent("Message")!

  return (_ctx.refund)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_PageHeader, {
          showDelete: false,
          showSave: false,
          title: `Dettaglio Rimborso #${_ctx.refund.id}`
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_BackButton)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_Panel, {
          header: "Informazioni Generali",
          class: "p-mb-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.refund.id), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Tag, {
                    value: _ctx.getStatusLabel(_ctx.refund.status),
                    severity: _ctx.getStatusSeverity(_ctx.refund.status)
                  }, null, 8, ["value", "severity"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatAmount(_ctx.refund.amount)), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_DateFormatted, {
                    date: _ctx.refund.created_at,
                    format: "DD/MM/YYYY HH:mm"
                  }, null, 8, ["date"])
                ])
              ]),
              (_ctx.refund.processed_at)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_DateFormatted, {
                        date: _ctx.refund.processed_at,
                        format: "DD/MM/YYYY HH:mm"
                      }, null, 8, ["date"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.refund.admin_notes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.refund.admin_notes), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Panel, {
          header: "Dati Bancari",
          class: "p-mb-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("code", null, _toDisplayString(_ctx.refund.iban || '-'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.refund.iban_holder || '-'), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Panel, {
          header: "Dati Fiscali",
          class: "p-mb-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_28, [
              (_ctx.refund.fiscal_code)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.refund.fiscal_code), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.refund.vat)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.refund.vat), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.refund.business_name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.refund.business_name), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.refund.business_address)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.refund.business_address), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.refund.business_city_name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.refund.business_city_name), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.refund.business_province)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.refund.business_province), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.refund.business_tel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.refund.business_tel), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.refund.business_note)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.refund.business_note), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        (_ctx.refund.entity)
          ? (_openBlock(), _createBlock(_component_Panel, {
              key: 0,
              header: "Richiedente",
              class: "p-mb-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.getEntityName(_ctx.refund.entity)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.refund.entity.email), 1)
                  ]),
                  (_ctx.refund.entity.business_name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _hoisted_61,
                        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.refund.entity.business_name), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.refund.entity.vat)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _hoisted_64,
                        _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.refund.entity.vat), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_component_Rating, {
                          modelValue: _ctx.refund.entity.rating_avg,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.refund.entity.rating_avg = $event)),
                          readonly: "",
                          cancel: false,
                          stars: 5
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("span", _hoisted_70, "(" + _toDisplayString(_ctx.refund.entity.rating_avg?.toFixed(1) || '0.0') + ")", 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
          _createVNode(_component_ProgressSpinner)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_72, [
          _createVNode(_component_Message, { severity: "error" }, {
            default: _withCtx(() => [
              _hoisted_73
            ]),
            _: 1
          })
        ]))
}